import type { GivingContentObjectDetail } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from 'permissions';
import { type MenuProps, UserSecurityLineIcon } from 'ui';
import { routes, useAdminDashboardRedirectMutation } from 'features/admin-dashboard';

export const useActions = ({ givingContentObject }: { givingContentObject: GivingContentObjectDetail }) => {
  const { t } = useTranslation();
  const { isPending: isRedirectingToAdminDashboard, mutate: redirectToAdminDashboard } =
    useAdminDashboardRedirectMutation();

  const { canViewGivingInAdmin } = usePermissions();

  return useMemo(() => {
    const actions: MenuProps['items'] = [];

    if (canViewGivingInAdmin({ givingContentObject })) {
      actions.push({
        disabled: isRedirectingToAdminDashboard,
        icon: <UserSecurityLineIcon />,
        key: 'view-in-admin-console',
        label: t('View in admin console'),
        onClick() {
          redirectToAdminDashboard({ referrer: routes.giving.detail(givingContentObject.giving.id) });
        },
      });
    }

    return {
      actions,
    };
  }, [givingContentObject, isRedirectingToAdminDashboard, redirectToAdminDashboard, t, canViewGivingInAdmin]);
};
